/**
 * Created by lihanying on 2017/11/3.
 */
import React from 'react'
import { Modal } from 'antd'
import ClubCommodityType from '../../ClubCommodityType'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { modalType } = this.props
    return (
      <div>
        <Modal
          title="商品分类"
          visible={modalType}
          onCancel={this.props.handleCancel}
          width="800px"
          footer={null}
        >
          <ClubCommodityType />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/modalType.js